import React, { Fragment } from "react";
import { Waypoint } from "react-waypoint";
import PropTypes from "prop-types";

import Spinner from "components/Library/Spinner";
import StreamItem from "stream/components/StreamItem";
import LoadingStoriesNotice from "components/Library/LoadingStoriesNotice";

import { STREAM_TYPE } from "config/constants";

import styles from "./PaginatedStream.css";

/**
 * PaginatedStream
 * This is the main stream (content feed) component on Axios.com
 * It takes content in via a prop called "Edges" (which is a graphQl convention)
 * and iterates over the array to return an array of "StreamItem" components.
 */
const PaginatedStream = ({
  edges,
  contentComponent,
  isLoading,
  stream,
  pageInfo,
  registerStreamItemNode,
  unregisterStreamItemNode,
  showSaveTag,
  fetchNextPage,
}) => {
  return (
    <>
      <div className={styles.root} data-testid="paginated-stream">
        {edges.map((edge, index) => {
          return (
            <Fragment key={edge.node.id}>
              <StreamItem
                edge={edge}
                index={index}
                key={edge.node.id}
                contentComponent={contentComponent}
                streamType={stream.type}
                registerStreamItemNode={registerStreamItemNode}
                unregisterStreamItemNode={unregisterStreamItemNode}
                showSaveTag={showSaveTag}
              />
              {pageInfo.hasNextPage && index === edges.length - 3 && (
                <Waypoint onEnter={() => fetchNextPage()} />
              )}
            </Fragment>
          );
        })}
        {isLoading && <Spinner />}
      </div>
      <LoadingStoriesNotice isLoading={isLoading} />
    </>
  );
};

export default PaginatedStream;

PaginatedStream.propTypes = {
  fetchNextPage: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  pageInfo: PropTypes.shape({
    hasNextPage: PropTypes.bool.isRequired,
  }).isRequired,
  edges: PropTypes.arrayOf(
    PropTypes.shape({
      node: PropTypes.object.isRequired,
    })
  ).isRequired,
  contentComponent: PropTypes.func.isRequired,
  stream: PropTypes.shape({
    type: PropTypes.oneOf(Object.values(STREAM_TYPE)).isRequired,
  }).isRequired,
  registerStreamItemNode: PropTypes.func,
  unregisterStreamItemNode: PropTypes.func,
  isClient: PropTypes.bool,
};
